import { ChevronLeftIcon } from "../../assets/icons";
import { Button } from "../Button";
import "./Section.scss";

/**
 * Section component
 * @param {{
 *   title?:string,
 *   className?:string,
 *   wrapperClassName?:string,
 *   children:import("react").ReactNode | import("react").ReactNode[]
 *   enableBackButton?:boolean,
 *   backButtonText?:string,
 *   onBackButtonClick?:() => void,
 * }} props
 * @returns
 */
function Section({
  title,
  className,
  wrapperClassName,
  children,
  enableBackButton = false,
  backButtonText = "Back",
  onBackButtonClick,
}) {
  return (
    <section className={`section ${wrapperClassName}`}>
      {title && (
        <div className="section-title">
          {enableBackButton && (
            <Button
              type="button"
              text={backButtonText}
              icon={<ChevronLeftIcon />}
              onClick={onBackButtonClick}
            />
          )}
          <h2>{title}</h2>
        </div>
      )}

      <div className={`section-content ${className}`}>{children}</div>
    </section>
  );
}

export default Section;
